import { ReactNode } from "react";
// MUI
import { Grid, Paper, Stack, Typography } from "@mui/material";

// Helpers
import { numberToReadableFormat } from "@Common/helpers/number";

// Types
export interface TooltipBarData {
	label: string;
	value: number;
	color: string;
}

type CustomizedTooltipProps = {
	bars: TooltipBarData[];
	showTotal?: boolean;
	formatter?: (value: number, dataKey: string) => string | ReactNode;
};

export function CustomizedTooltip(props: CustomizedTooltipProps) {
	const { bars, showTotal = true, formatter = numberToReadableFormat } = props;

	if (!bars?.length) {
		return null;
	}

	const total = bars.reduce((sum, bar) => sum + bar.value, 0);
	const displayBars = showTotal ? [...bars, { label: "Total", value: total, color: "#666666" }] : bars;

	return (
		<Paper elevation={3} className={"!rounded-[10px]"}>
			<Grid container direction={"row"} xs={12}>
				<Grid item xs={6}>
					<Stack component={"ul"} py={2} px={4} spacing={1}>
						{displayBars.map((bar, index) => (
							<Typography
								key={index}
								component={"li"}
								className={"!font-sans !font-bold !text-xs"}
								style={{ color: bar.color }}
							>
								{bar.label}
							</Typography>
						))}
					</Stack>
				</Grid>
				<Grid item xs={6}>
					<Stack component={"ul"} py={2} px={3} spacing={1}>
						{displayBars.map((bar, index) => (
							<Typography
								key={index}
								component={"li"}
								className={"!font-sans !font-bold !text-xs"}
								style={{ color: bar.color }}
							>
								{formatter(bar.value, "")}
							</Typography>
						))}
					</Stack>
				</Grid>
			</Grid>
		</Paper>
	);
}
